<template>
  <div>
    <material-card
      :text="`${type}`"
      color="orange">
      <div style="padding:5px 10px; background-color:">
        <Can
            I="manage"
            a="reports"
          >
        <v-layout wrap>
          <v-flex
            xl12
            style="text-align:right">
            <HelperCsvDownload
              :data="FilteredAccounts"
              @csv-download-success="downloadFinished"/>
          </v-flex>
        </v-layout>
        </Can>
        <v-layout wrap>
          <v-flex xl3>
            <v-text-field
              v-model="search"
              label="Search"
              hide-details
              append-icon="search"
              placeholder="Search"
            />
          </v-flex>
          <v-flex xl3>
            <v-select
              v-model="selectedFilter"
              :items="['All','New']"
              item-value="value"
              label="Filter by"
              attach
            />
          </v-flex>

          <v-flex xl2>
            <v-select
              v-model="selectedFinance"
              :items="financesystemlists"
              attach
              label="Financial System"
              multiple
            />
          </v-flex>

          <v-flex xl2>
            <v-dialog
              ref="billingDateModal"
              v-model="billingDateModal"
              :return-value.sync="billingdate"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="computedBillingDate"
                  label="Service Period"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="billingdate"
                scrollable>
                <v-spacer/>
                <v-btn
                  text
                  @click="modal = false">Cancel</v-btn>
                <v-btn
                  text
                  @click="$refs.billingDateModal.save(billingdate)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>

          <v-flex xl2>
            <v-dialog
              ref="startDateModal"
              v-model="startDateModal"
              :return-value.sync="startDate"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="computedStartDateFormatted"
                  label="WBS End Date (From)"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="startDate"
                scrollable>
                <v-spacer/>
                <v-btn
                  text
                  @click="startDateModal = false">Cancel</v-btn>
                <v-btn
                  text
                  @click="$refs.startDateModal.save(startDate)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>

          <v-flex xl2>
            <v-dialog
              ref="endDateModal"
              v-model="endDateModal"
              :return-value.sync="date"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="computedDateFormatted"
                  label="WBS End Date (To)"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="date"
                scrollable>
                <v-spacer/>
                <v-btn
                  text
                  @click="endDateModal = false">Cancel</v-btn>
                <v-btn
                  text
                  @click="$refs.endDateModal.save(date)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>
          
        </v-layout>
      </div>
      <v-progress-linear
        v-slot:progress
        v-if="loadingRequest"
        color="orange"
        indeterminate/>
      <v-data-table
        :headers="accountHeaders"
        :items="FilteredAccounts"
        :search="search"
        :pagination.sync="pagination"
        v-model="selected"
        class="accounts-table"
      >
        <template
          slot="headerCell"
          slot-scope="{ header }">
          <span
            class="subheading font-weight-light text-success text-md-left text--darken-3"
            v-text="header.text"
          />
        </template>
        <template v-slot:items="props">
          <tr :active="props.selected">
            <!-- <td>
              <v-checkbox
                v-model="props.selected"
                color="orange"
                hide-details
              ></v-checkbox>
            </td>-->
            <td>
              <Can
                i="manage"
                a="admin">
                <v-layout
                  align-left
                  justify-left>
                  <v-icon
                    small
                    title="Edit"
                    class="mr-2"
                    color="primary"
                    flat
                    @click="editItem(props.item)"
                  >edit</v-icon>
                  <v-icon
                    small
                    title="Changelogs"
                    class="mr-2"
                    color="primary"
                    flat
                    @click="onShowLogs(props.item)"
                  >history</v-icon>
                </v-layout>
              </Can>
            </td>
            <!-- <td>{{ props.item.Financial_Period_Id }}</td> -->
            <td>{{ props.item.PayerAccountId }}</td>
            <td>{{ props.item.LinkedAccountId }}</td>
            <td>{{ props.item.LinkedAccountName }}</td>
            <td>{{ props.item.Billing_Period }}</td>
            <td>{{ props.item.CloudCheckr_Cost }}</td>
            <td>{{ props.item.AWS_Discount }}</td>
            <td>{{ props.item.DXC_Discount }}</td>
            <td>{{ props.item.Additional_Discount }}</td>
            <td>{{ props.item.Uplift }}</td>
            <td>{{ props.item.Credit_Backbill }}</td>
            <td>{{ props.item.Total_Costs_to_Allocate }}</td>
            <td>{{ props.item.Estimated_Monthly_Revenue }}</td>
            <td>{{ props.item.Estimated_Twelve_Month_Revenue }}</td>
            <td>{{ props.item.Credits_Remaining }}</td>
            <td>{{ props.item.Service_Product }}</td>
            <td>{{ props.item.Can_Allocate }}</td>
            <td>{{ props.item.WBS }}</td>
            <td>{{ props.item.WBS_End_Date }}</td>
            <td>{{ props.item.IWO_Number }}</td>
            <td>{{ props.item.Originating_Org_WBS }}</td>
            <td>{{ props.item.Cost_Center }}</td>
            <td>{{ props.item.Client_Name }}</td>
            <td>{{ props.item.Horizon_Client_Name }}</td>
            <td>{{ props.item.Revenue_Missing_from_Horizon }}</td>
            <td>{{ props.item.Region }}</td>
            <td>{{ props.item.Account_Type }}</td>
            <td>{{ props.item.Major_Offering_Code }}</td>
            <td>{{ props.item.Major_Offering_Name }}</td>
            <td>{{ props.item.SFDC_Opp_ID }}</td>
            <td>{{ props.item.SFDC_Opp_Status }}</td>
            <td>{{ props.item.AWS_on_Opp }}</td>
            <td>{{ props.item.Financial_System }}</td>
            <td>{{ props.item.CR_Redeemed_from_AWS }}</td>
            <td>{{ props.item.CR_Used }}</td>
            <td>{{ props.item.Exceptions }}</td>
            <td>{{ props.item.Contract }}</td>
            <td>{{ props.item.Notes }}</td>
            <td>{{ props.item.Galaxy_Service_Level }}</td>
          </tr>
        </template>
      </v-data-table>
    </material-card>
  </div>
</template>
<script>
import { METHODS } from 'http'
import { mapMutations, mapState, mapActions, mapGetters } from 'vuex'
import { access } from 'fs'

export default {
  data: vm => ({
    startDate: null,
    date: null,
    billingdate: null,
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    menu: false,
    startDateModal: false,
    endDateModal: false,
    billingDateModal: false,
    modal: false,
    menu2: false,
    selectedFilter: 'All',
    selectedFinance: ['All'],
    search: '',
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      totalItems: 0
    },

    financesystemlists: ['All', 'CSC', 'ES', 'MASTER ACCOUNT', 'SUSPENDED'],
    blurConfig: {
      isBlurred: true,
      opacity: 0.9,
      filter: 'blur(2.2px)',
      transition: 'all .5s linear'
    }
  }),
  // eslint-disable-next-line vue/order-in-components
  props: {
    title: {
      type: String,
      default: 'byAwsAgreement' // i.e. byAwsAgreement, byMasterPayer, byCustomer
    },
    type: {
      type: String,
      default: 'agreement' // i.e. byAwsAgreement, byMasterPayer, byCustomer
    }
  },
  computed: {
    ...mapState('admin/financialAdministration', ['loadingRequest', 'accountHeaders', 'allAccounts']),
    computedStartDateFormatted () {
      return this.formatDate(this.startDate)
    },
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    computedBillingDate () {
      return this.formatBillingDate(this.billingdate)
    },
    FilteredAccounts () {
      let records = []
      // filter by type
      switch (this.type) {
        case 'agreement':
          records = this.allAccounts
          break
        case 'masterpayer':
          records = this.allAccounts.filter(account => account.PayerAccountId == this.$route.params.id)
          // records = this.allAccounts.filter( account => (account.PayerAccountId == this.$route.params.id && account.Contract.toLowerCase() == this.$route.query.agreement))
          break
        case 'customers':
          records = this.allAccounts.filter(account => account.Client_Name == this.$route.params.id)
          break
        case 'linkedaccount':
          records = this.allAccounts.filter(account => account.LinkedAccountId == this.$route.params.id)
          break
        default:
          records = this.allAccounts
          break
      }
      // additional filter
      // if(this.selectedFilter==='All' || this.selectedFilter===''){
      //   if(this.selectedFinance.includes('All')){
      //     return records
      //   } else {
      //     return records.filter( account => (this.selectedFinance.includes(account.Financial_System)))
      //   }
      // } else {
      //   if(this.selectedFinance.includes('All')){
      //     return records.filter(account => account.CloudCheckr_Cost == '0')
      //   } else {
      //     return records.filter( account => account.CloudCheckr_Cost == '0' && (this.selectedFinance.includes(account.Financial_System)))
      //   }
      // }

      // additional filter
      if (this.selectedFilter === 'All' || this.selectedFilter === '') {
        if (this.selectedFinance.includes('All')) {
          let startDate = new Date(this.startDate)
          let fromDate = new Date(this.date)

          if (this.startDate !== null && this.date !== null) {
            return records.filter(account =>
              new Date(account.WBS_End_Date).getTime() >= startDate.getTime() &&
                new Date(account.WBS_End_Date).getTime() <= fromDate.getTime()
            )
          } else if (this.startDate !== null && this.date === null) {
            return records.filter(account =>
              new Date(account.WBS_End_Date).getTime() >= startDate.getTime()
            )
          } else if (this.startDate === null && this.date !== null) {
            return records.filter(account =>
              new Date(account.WBS_End_Date).getTime() >= fromDate.getTime()
            )
          } else {
            return records
          }
        } else {
          let startDate = new Date(this.startDate)
          let fromDate = new Date(this.date)
          if (this.startDate !== null && this.date !== null) {
            return records.filter(account =>
              this.selectedFinance.includes(account.Financial_System) &&
               new Date(account.WBS_End_Date).getTime() >= startDate.getTime() &&
               new Date(account.WBS_End_Date).getTime() <= fromDate.getTime()
            )
          } else if (this.startDate !== null && this.date === null) {
            return this.allAccounts.filter(account =>
              this.selectedFinance.includes(account.Financial_System) &&
              new Date(account.WBS_End_Date).getTime() >= startDate.getTime()
            )
          } else if (this.startDate === null && this.date !== null) {
            return this.allAccounts.filter(account =>
              this.selectedFinance.includes(account.Financial_System) &&
              new Date(account.WBS_End_Date).getTime() >= fromDate.getTime()
            )
          } else {
            return records.filter(account => this.selectedFinance.includes(account.Financial_System))
          }
          // return records.filter( account => (this.selectedFinance.includes(account.Financial_System)))
        }
      } else {
        if (this.selectedFinance.includes('All')) {
          let startDate = new Date(this.startDate)
          let fromDate = new Date(this.date)

          if (this.startDate !== null && this.date !== null) {
            return records.filter(account =>
              account.CloudCheckr_Cost == '0' &&
                new Date(account.WBS_End_Date).getTime() >= startDate.getTime() &&
                new Date(account.WBS_End_Date).getTime() <= fromDate.getTime()
            )
          } else if (this.startDate !== null && this.date === null) {
            return records.filter(
              account =>
                account.CloudCheckr_Cost == '0' &&
                new Date(account.WBS_End_Date).getTime() >= startDate.getTime()
            )
          } else if (this.startDate === null && this.date !== null) {
            return records.filter(account =>
              account.CloudCheckr_Cost == '0' &&
                new Date(account.WBS_End_Date).getTime() >= fromDate.getTime()
            )
          } else {
            return this.allAccounts.filter(account => account.CloudCheckr_Cost == '0')
          }
          // return records.filter(account => account.CloudCheckr_Cost == '0')
        } else {
          let startDate = new Date(this.startDate)
          let fromDate = new Date(this.date)

          if (this.startDate !== null && this.date !== null) {
            return records.filter(account =>
              account.CloudCheckr_Cost == '0' &&
              this.selectedFinance.includes(account.Financial_System) &&
              new Date(account.WBS_End_Date).getTime() >= startDate.getTime() &&
              new Date(account.WBS_End_Date).getTime() <= fromDate.getTime()
            )
          } else if (this.startDate !== null && this.date === null) {
            return records.filter(account =>
              account.CloudCheckr_Cost == '0' &&
              this.selectedFinance.includes(account.Financial_System) &&
              new Date(account.WBS_End_Date).getTime() >= startDate.getTime()
            )
          } else if (this.startDate === null && this.date !== null) {
            return records.filter(account =>
              account.CloudCheckr_Cost == '0' &&
              this.selectedFinance.includes(account.Financial_System) &&
              new Date(account.WBS_End_Date).getTime() <= fromDate.getTime()
            )
          } else {
            return records.filter(account => account.CloudCheckr_Cost == '0' &&
                this.selectedFinance.includes(account.Financial_System)
            )
          }
          // return records.filter( account => account.CloudCheckr_Cost == '0' && (this.selectedFinance.includes(account.Financial_System)))
        }
      }
    }
  },
  mounted () {},
  methods: {
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },
    formatBillingDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${year}-${month}`
    },
    parseDate (date) {
      if (!date) return null
      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    editItem (item) {
      this.$store.commit('admin/openFinanceMonthlyCrossDialog', {
        show: true,
        type: 'edit',
        fields: { ...item },
        submitLabel: 'Update',
        submitHandler: () => {
          this.$store.dispatch('admin/updateFinanceAccount')
        }
      })
      this.$store.commit(
        'setChangeLogRecord',
        { id: item.LinkedAccountId, changeFrom: { ...item } },
        { root: true }
      )
    },

    onShowLogs (account) {
      this.$store.dispatch('showLogRecords', account.LinkedAccountId)
    }
  }
}
</script>
<style>
</style>
